<template>
  <div class="loading uni-flex-center uni-flex-column" v-if="isShow">
    <img src="https://qiniu.tfzhongchukeji.com/imgs/v-loading.png" class="loading-img"/>
    <p class="loading-text">加载中...</p>
  </div>
</template>


<script lang="ts" setup>
  import { ref,reactive,onMounted } from 'vue'
  const isShow = ref<boolean>(false)

  const show = () => isShow.value = true
  const hide = () => isShow.value = false

  // 暴露
  defineExpose({
    isShow,
    show,
    hide
  })

</script>

<style lang="scss" scoped>
.loading{
  position: fixed;
  top:0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: #f5f5f5;
  &-img{
    width: 130px;
    height: 70px;
  }
  &-text{
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 30px;
    text-align: center;
    color: #969696;
    margin-top: 24px;
  }
}
</style>